import { ApiResource } from './api-resource';
import { Type } from '@angular/core';
import { getInstanceOrClassMetadata } from '../util/metadata';

export const ENDPOINT = Symbol('Endpoint');
export const Endpoint =
  (slug: string, resourceTypeName: string): ClassDecorator =>
  (target) =>
    Reflect.defineMetadata(ENDPOINT, [slug, resourceTypeName], target);

export function getEndpointOf(
  resource: ApiResource<any> | Type<ApiResource<any>>,
): string | undefined {
  return getInstanceOrClassMetadata(resource, ENDPOINT)?.[0];
}

export function getResourceTypeName(
  resource: ApiResource<any> | Type<ApiResource<any>>,
): string {
  return getInstanceOrClassMetadata(resource, ENDPOINT)[1];
}
